import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { BUSINESS } from "../data/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-navy py-14">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <a href="#top" className="flex items-center">
              <img src="/hylyte-hd-logo.png" alt="Hylyte Digital" className="h-10 w-auto" />
            </a>
            <p className="mt-4 text-sm text-muted leading-relaxed max-w-xs">
              One-stop shop for everything digital. 100% Australian made, custom original work.
            </p>
          </div>
          <div className="flex flex-col gap-3 text-sm">
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted">Contact</p>
            <a href={BUSINESS.phoneHref} className="flex items-center gap-2 text-muted hover:text-white transition-colors">
              <Phone size={14} className="text-signal" /> {BUSINESS.phone}
            </a>
            <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 text-muted hover:text-white transition-colors">
              <Mail size={14} className="text-signal" /> {BUSINESS.email}
            </a>
            <p className="flex items-start gap-2 text-muted">
              <MapPin size={14} className="text-signal mt-0.5 shrink-0" /> {BUSINESS.address}
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted">Follow</p>
            <div className="flex gap-3">
              <a href={BUSINESS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="social-facebook" className="grid place-items-center w-10 h-10 rounded-lg glass text-muted hover:text-signal hover:border-signal/60 transition-colors">
                <Facebook size={16} />
              </a>
              <a href={BUSINESS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram" className="grid place-items-center w-10 h-10 rounded-lg glass text-muted hover:text-signal hover:border-signal/60 transition-colors">
                <Instagram size={16} />
              </a>
            </div>
            <p className="text-xs text-muted mt-2">{BUSINESS.serviceArea}</p>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-muted">© {new Date().getFullYear()} Hylyte Digital. All rights reserved.</p>
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted">We design &amp; develop customised web applications</p>
        </div>
      </div>
    </footer>
  );
};
